import {useContext, useMemo} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row } from "antd";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	SelectField,
} from "~/components/Forms";
import {AppContext} from "../../../../context/AppProvider";

function UserFormAdd({onHandleSubmit})
{
    const {rolesData} = useContext(AppContext);

    const rolesOptions = useMemo(() => {
        return [...Object.entries(rolesData).map(([key, value]) => {
            return {
                value: key,
                label: value
            };
        })];
    }, []);

	const initialValues = {
		username: undefined,
		password: undefined,
		firstname: undefined,
		lastname: undefined,
		email: undefined,
		phone: undefined,
        role: "personnel"
	}

	const validationSchema = Yup.object().shape({
		username: Yup.string()
			.required('Tên đăng nhập không được để trống')
			.matches(/^[a-zA-Z][a-zA-Z0-9_]*$/, "Username chỉ được chứa chữ cái, số và dấu gạch dưới, bắt đầu bằng chữ cái.")
			.min(6, "Username phải chứa ít nhất 6 ký tự.")
			.max(20, "Username không được dài quá 20 ký tự."),
		password: Yup.string()
			.required('Mật khẩu không được để trống')
			.min(8, "Mật khẩu phải chứa ít nhất 8 ký tự.")
			.max(32, "Mật khẩu không được dài quá 32 ký tự.")
			.notOneOf(['123456', '123456789', '12345678', 'password', 'abc123', 'qwerty'], "Mật khẩu không được dễ đoán."),
		firstname: Yup.string().required('Họ chữ đệm thành viên không được để trống'),
		lastname: Yup.string().required('Tên thành viên không được để trống'),
		email: Yup.string().required('Email thành viên không được để trống').email('Email không đúng định dạng'),
		phone: Yup.string().required('Số điện thoại thành viên không được để trống'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors } } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const onSubmit = async (data) => {
		await onHandleSubmit(data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Thông tin đăng nhập</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="username" render={({ field }) => (
						<InputField label="Tên đăng nhập" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="password" render={({ field }) => (
						<InputField label="Mật khẩu" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<p className="heading mt-2">Thông tin nhân viên</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="firstname" render={({field}) => (
						<InputField label="Họ chữ đệm" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="lastname" render={({field}) => (
						<InputField label="Tên" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="phone" render={({field}) => (
						<InputField label="Số điện thoại" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="email" render={({field}) => (
						<InputField label="Email" errors={errors} {...field}/>
					)}/>
				</Col>
                <Col className="gutter-row" span={24}>
                    <Controller control={control} name="role" render={({field}) => (
                        <SelectField label="Chức Vụ" options={rolesOptions} errors={errors} {...field}/>
                    )}/>
                </Col>
			</Row>

			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button background blue type="submit">Thêm Nhân Viên</Button>
			</div>
		</form>
	)
}

export default UserFormAdd;